import { Locales } from '@griply/types';
import Dialog from '@mui/material/Dialog';
import React, { Suspense } from 'react';
import { DialogVariantOptions } from 'shared/assets/styles';
import { PageLoader } from 'shared/components/ui/page-loader';
import {
  DateFormatOptions,
  TimeFormatOptions,
} from 'shared/types/date-format-options';
import { NumberFormatOptions } from 'shared/types/number-format-options';
import { ThemeModes } from 'shared/types/theme-modes';
import { WeekDays } from 'shared/types/week-days';

import { SettingsForm } from './settings-form';

export type UserSettingsDialogProps = {
  open: boolean;
  onClose: () => void;
  userName: string;
  updateUserName: (name: string) => void;
  language?: Locales;
  onChangeLanguage: (locale: Locales) => void;
  email: string;
  isSignedInWithProvider: boolean;
  numberFormat?: NumberFormatOptions;
  onChangeNumberFormat: (dateFormat: NumberFormatOptions) => void;
  dateFormat: DateFormatOptions;
  onChangeDateFormat: (dateFormat: DateFormatOptions) => void;
  timeFormat: TimeFormatOptions;
  onChangeTimeFormat: (dateFormat: TimeFormatOptions) => void;
  weekStartsOn: WeekDays;
  onChangeWeekStart: (weekDay: WeekDays) => void;
  onChangePassword: () => void;
  themePreference: ThemeModes;
  onChangeThemePreference: (themeMode: ThemeModes) => void;
};

export const UserSettingsDialog: React.FC<UserSettingsDialogProps> = ({
  open,
  onClose,
  userName,
  updateUserName,
  language,
  onChangeLanguage,
  email,
  isSignedInWithProvider,
  numberFormat,
  onChangeNumberFormat,
  dateFormat,
  onChangeDateFormat,
  timeFormat,
  onChangeTimeFormat,
  weekStartsOn,
  onChangeWeekStart,
  onChangePassword,
  themePreference,
  onChangeThemePreference,
}) => {
  return (
    <Dialog
      open={open}
      fullWidth
      onClose={onClose}
      variant={DialogVariantOptions.Large}
    >
      <Suspense fallback={<PageLoader />}>
        <SettingsForm
          onClose={onClose}
          name={userName}
          onChangeName={updateUserName}
          language={language}
          onChangeLanguage={onChangeLanguage}
          email={email}
          isSignedInWithProvider={isSignedInWithProvider}
          numberFormat={numberFormat}
          onChangeNumberFormat={onChangeNumberFormat}
          dateFormat={dateFormat}
          onChangeDateFormat={onChangeDateFormat}
          timeFormat={timeFormat}
          onChangeTimeFormat={onChangeTimeFormat}
          weekStartsOn={weekStartsOn}
          onChangeWeekStart={onChangeWeekStart}
          onChangePassword={onChangePassword}
          themePreference={themePreference}
          onChangeThemePreference={onChangeThemePreference}
        />
      </Suspense>
    </Dialog>
  );
};
